import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, MessageCircle } from 'lucide-react';

const footerLinks = {
  fix: [
    { name: 'Mechanical Repairs', path: '/mechanical' },
    { name: 'Vehicle Servicing', path: '/mechanical' },
    { name: 'Panel Beating', path: '/panel-beating' },
    { name: 'Accident Repairs', path: '/panel-beating' },
  ],
  detail: [
    { name: 'Detailing Packages', path: '/detailing' },
    { name: 'Paint Correction', path: '/paint-correction' },
    { name: 'Ceramic Coating', path: '/ceramic-coating' },
    { name: 'Our Work', path: '/gallery' },
  ],
  company: [
    { name: 'About', path: '/' },
    { name: 'Contact', path: '/contact-us' },
    { name: 'Book Now', path: '/booking' },
    { name: 'Get a Quote', path: '/repair-quote' },
    { name: 'Fleet Services', path: '/fleet-services' },
  ],
  customerCare: [
    { name: 'Terms & Conditions', path: '/terms' },
    { name: 'Refund & Cancellation Policy', path: '/refund-policy' },
    { name: 'Privacy & POPIA Policy', path: '/privacy-policy' },
    { name: 'Service Fulfilment Policy', path: '/service-policy' },
    { name: 'Payment Information', path: '/payment-info' },
    { name: 'Contact Us', path: '/contact-us' },
  ],
};

export default function Footer() {
  const whatsappNumber = '27760784050';
  const whatsappMessage = encodeURIComponent('Hi MA Africa, I would like to enquire about your services.');

  return (
    <footer data-testid="footer" className="bg-[#1d1d1f]">
      {/* Main Footer */}
      <div className="max-w-[1200px] mx-auto px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <h3 className="text-lg font-bold text-white mb-2">MA Africa</h3>
            <p className="text-xs text-gray-400 mb-4">FIX. RESTORE. DETAIL.</p>
            <p className="text-xs text-gray-500 leading-relaxed">
              Complete automotive care under one roof.
            </p>
          </div>

          {/* Fix */}
          <div>
            <h4 className="text-xs font-semibold text-white uppercase tracking-wider mb-4">Fix</h4>
            <ul className="space-y-2">
              {footerLinks.fix.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path} 
                    className="text-xs text-gray-400 hover:text-[#C41E3A] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Detail */}
          <div>
            <h4 className="text-xs font-semibold text-white uppercase tracking-wider mb-4">Detail</h4>
            <ul className="space-y-2">
              {footerLinks.detail.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path} 
                    className="text-xs text-gray-400 hover:text-[#C41E3A] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-semibold text-white uppercase tracking-wider mb-4">Company</h4>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path} 
                    className="text-xs text-gray-400 hover:text-[#C41E3A] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Customer Care */}
          <div>
            <h4 className="text-xs font-semibold text-white uppercase tracking-wider mb-4">Customer Care</h4>
            <ul className="space-y-2">
              {footerLinks.customerCare.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path} 
                    className="text-xs text-gray-400 hover:text-[#C41E3A] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-semibold text-white uppercase tracking-wider mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="tel:0760784050" 
                  className="flex items-center gap-2 text-xs text-gray-400 hover:text-[#C41E3A] transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone className="w-3 h-3" />
                  076 078 4050
                </a>
              </li>
              <li>
                <a 
                  href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-xs text-gray-400 hover:text-[#25D366] transition-colors"
                  data-testid="footer-whatsapp"
                >
                  <MessageCircle className="w-3 h-3" />
                  WhatsApp
                </a>
              </li>
              <li>
                <a 
                  href="mailto:info@maafricafixanddetail.co.za" 
                  className="flex items-center gap-2 text-xs text-gray-400 hover:text-[#C41E3A] transition-colors"
                  data-testid="footer-email"
                >
                  <Mail className="w-3 h-3" />
                  Email Us
                </a>
              </li>
              <li className="flex items-start gap-2 text-xs text-gray-500">
                <MapPin className="w-3 h-3 mt-0.5 flex-shrink-0" />
                <span>
                  68 Serenade Road<br />
                  Henville, Germiston
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-8 border-t border-gray-800">
          <Link
            to="/booking"
            className="inline-flex items-center justify-center bg-[#C41E3A] text-white text-sm font-semibold px-8 py-3 rounded-lg hover:bg-[#a01830] transition-colors"
          >
            Book a Service
          </Link>
          <Link
            to="/repair-quote"
            className="inline-flex items-center justify-center bg-transparent text-white text-sm font-semibold px-8 py-3 rounded-lg border border-gray-700 hover:border-[#C41E3A] hover:text-[#C41E3A] transition-colors"
          >
            Request a Repair Quote
          </Link>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-[1200px] mx-auto px-6 py-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[11px] text-gray-500">
              © {new Date().getFullYear()} MA Africa Fix & Detail. All rights reserved.
            </p>
            <p className="text-[11px] text-gray-600">
              One Vehicle. One Team. Complete Care.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
